<template>
  <label class="checkbox-inline i-checks" ref="option_label"> 
    <span style="position: relative;">
      <input type="radio" :value="setting" :checked="shouldBeChecked" v-bind:name="name" /> {{label}}&nbsp;&nbsp;&nbsp;
    </span>
  </label>
</template>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormOption",
  model: {
    event: 'change'
  },
  mixins: [formField],
  props: {
    label: String,
    name: String,
    setting: String,
    value: String,
    inline: String
  },
  watch: {
    value: function(newVal, oldVal) {
      var elementId = this.$refs.option_label
      $(elementId).iCheck(this.setting == newVal ? 'check' : 'uncheck')
    }
  },
  mounted() {
    var self = this;
    var elementId = this.$refs.option_label

    $(elementId).iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green',
    });
    // Note: iCheck prevents vue's onchange event handling
    $(elementId).on('ifChecked', function(event) {
      self.$emit('change', self.setting)
    });
  },
  computed: {
    shouldBeChecked() {
      return this.setting == this.value
    }
  }
};
</script>
